export default "__VITE_ASSET__raJt14A5__"